// @mui
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import AppPermissionGate from 'src/components/common/AppPermissionGate';
// components
import Iconify from 'src/components/iconify';
import TextMaxLine from 'src/components/text-max-line/text-max-line';
import AppPermissions from 'src/constants/app-permissions';
import useLocales from 'src/locales/use-locales';
import { RouterLink } from 'src/routes/components';
import { KnowledgeBasesDto } from 'src/types/knowledge-bases';
import { getLocalizedValue } from 'src/utils/get-localized-value';

// ----------------------------------------------------------------------

type Props = {
  row: KnowledgeBasesDto;
  deleteHandler: (mutoonId: string) => void;
};

export default function KnowledgeBasesRow({ row, deleteHandler }: Props) {
  const { t } = useLocales();
  const router = useNavigate();

  const handleEdit = () => {
    router(`${row.knowledgeBaseId}`, { state: { book: row } });
  };

  return (
    <>
      <TableRow hover>
        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
          {getLocalizedValue(row.title)}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'wrap', textAlign: 'center' }}>
          <TextMaxLine>{getLocalizedValue(row.content)}</TextMaxLine>
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
          {moment(row.createdAt).format('YYYY-MM-DD')}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
          <AppPermissionGate permissionsName={[AppPermissions.KNOWLEDGE_BASES_VIEW]}>
            <Tooltip title={t('tableLabels.preview')} placement="bottom" arrow>
              <IconButton href={row.cover_url!} target="_blank" LinkComponent={RouterLink}>
                <Iconify icon="mdi:eye-circle" width="27" height="27" color="#4A8769" />
              </IconButton>
            </Tooltip>
          </AppPermissionGate>
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
          <AppPermissionGate permissionsName={[AppPermissions.KNOWLEDGE_BASES_EDIT]}>
            <Tooltip title={t('tableLabels.edit')} placement="bottom" arrow>
              <IconButton onClick={handleEdit}>
                <Iconify icon="fluent-mdl2:page-edit" width="27" height="27" color="#FFAB8B" />
              </IconButton>
            </Tooltip>
          </AppPermissionGate>

          <AppPermissionGate permissionsName={[AppPermissions.KNOWLEDGE_BASES_DELETE]}>
            <Tooltip title={t('tableLabels.delete')} placement="bottom" arrow>
              <IconButton
                LinkComponent={RouterLink}
                onClick={() => deleteHandler(row.knowledgeBaseId)}
              >
                <Iconify
                  icon="material-symbols:delete-outline"
                  width="27"
                  height="27"
                  color="#DDB6FF"
                />
              </IconButton>
            </Tooltip>
          </AppPermissionGate>
        </TableCell>
      </TableRow>
    </>
  );
}
